/**
* Created by ctsi-biyi-generator
*/
export default {
'zh-CN': {
'tqtVisit.id.label': '',
'tqtVisit.id.holder': '请输入',
'tqtVisit.id.max': '最多11个字符',
'tqtVisit.id.required': '必填',
'tqtVisit.searchId.holder': '搜索',
'tqtVisit.userId.label': '发起人id',
'tqtVisit.userId.holder': '请输入发起人id',
'tqtVisit.userId.max': '发起人id最多11个字符',
'tqtVisit.userId.required': '发起人id必填',
'tqtVisit.searchUserId.holder': '搜索发起人id',
'tqtVisit.name.label': '发起人姓名',
'tqtVisit.name.holder': '请输入发起人姓名',
'tqtVisit.name.max': '发起人姓名最多18个字符',
'tqtVisit.name.required': '发起人姓名必填',
'tqtVisit.searchName.holder': '搜索发起人姓名',
'tqtVisit.concatPhone.label': '联系方式',
'tqtVisit.concatPhone.holder': '请输入联系方式',
'tqtVisit.concatPhone.max': '联系方式最多11个字符',
'tqtVisit.concatPhone.required': '联系方式必填',
'tqtVisit.searchConcatPhone.holder': '搜索联系方式',
'tqtVisit.createTime.label': '发起时间',
'tqtVisit.createTime.holder': '请输入发起时间',
'tqtVisit.createTime.max': '发起时间最多null个字符',
'tqtVisit.createTime.required': '发起时间必填',
'tqtVisit.searchCreateTime.holder': '搜索发起时间',
'tqtVisit.duty.label': '职位',
'tqtVisit.duty.holder': '请输入职位',
'tqtVisit.duty.max': '职位最多54个字符',
'tqtVisit.duty.required': '职位必填',
'tqtVisit.searchDuty.holder': '搜索职位',
'tqtVisit.deptName.label': '单位',
'tqtVisit.deptName.holder': '请输入单位',
'tqtVisit.deptName.max': '单位最多54个字符',
'tqtVisit.deptName.required': '单位必填',
'tqtVisit.searchDeptName.holder': '搜索单位',
'tqtVisit.visitTime.label': '走访时间',
'tqtVisit.visitTime.holder': '请输入走访时间',
'tqtVisit.visitTime.max': '走访时间最多null个字符',
'tqtVisit.visitTime.required': '走访时间必填',
'tqtVisit.searchVisitTime.holder': '搜索走访时间',
'tqtVisit.followPerson.label': '随同人员',
'tqtVisit.followPerson.holder': '请输入随同人员',
'tqtVisit.followPerson.max': '随同人员最多255个字符',
'tqtVisit.followPerson.required': '随同人员必填',
'tqtVisit.searchFollowPerson.holder': '搜索随同人员',
'tqtVisit.visitContent.label': '走访内容',
'tqtVisit.visitContent.holder': '请输入走访内容',
'tqtVisit.visitContent.max': '走访内容最多255个字符',
'tqtVisit.visitContent.required': '走访内容必填',
'tqtVisit.searchVisitContent.holder': '搜索走访内容',
'tqtVisit.companyCode.label': '统一社会信用代码',
'tqtVisit.companyCode.holder': '请输入统一社会信用代码',
'tqtVisit.companyCode.max': '统一社会信用代码最多18个字符',
'tqtVisit.companyCode.required': '统一社会信用代码必填',
'tqtVisit.searchCompanyCode.holder': '搜索统一社会信用代码',
'tqtVisit.companyName.label': '企业名称',
'tqtVisit.companyName.holder': '请输入企业名称',
'tqtVisit.companyName.max': '企业名称最多54个字符',
'tqtVisit.companyName.required': '企业名称必填',
'tqtVisit.searchCompanyName.holder': '搜索企业名称',
'tqtVisit.companyConcatName.label': '企业联系人',
'tqtVisit.companyConcatName.holder': '请输入企业联系人',
'tqtVisit.companyConcatName.max': '企业联系人最多128个字符',
'tqtVisit.companyConcatName.required': '企业联系人必填',
'tqtVisit.searchCompanyConcatName.holder': '搜索企业联系人',
'tqtVisit.companyConcatPhone.label': '联系方式',
'tqtVisit.companyConcatPhone.holder': '请输入联系方式',
'tqtVisit.companyConcatPhone.max': '联系方式最多11个字符',
'tqtVisit.companyConcatPhone.required': '联系方式必填',
'tqtVisit.searchCompanyConcatPhone.holder': '搜索联系方式',
'tqtVisit.visitFeedbackContent.label': '走访员反馈详情',
'tqtVisit.visitFeedbackContent.holder': '请输入走访员反馈详情',
'tqtVisit.visitFeedbackContent.max': '走访员反馈详情最多255个字符',
'tqtVisit.visitFeedbackContent.required': '走访员反馈详情必填',
'tqtVisit.searchVisitFeedbackContent.holder': '搜索走访员反馈详情',
'tqtVisit.visitFeedbackImg.label': '走访员反馈图片',
'tqtVisit.visitFeedbackImg.holder': '请输入走访员反馈图片',
'tqtVisit.visitFeedbackImg.max': '走访员反馈图片最多524个字符',
'tqtVisit.visitFeedbackImg.required': '走访员反馈图片必填',
'tqtVisit.searchVisitFeedbackImg.holder': '搜索走访员反馈图片',
'tqtVisit.visitFeedbackTime.label': '走访反馈时间',
'tqtVisit.visitFeedbackTime.holder': '请输入走访反馈时间',
'tqtVisit.visitFeedbackTime.max': '走访反馈时间最多null个字符',
'tqtVisit.visitFeedbackTime.required': '走访反馈时间必填',
'tqtVisit.searchVisitFeedbackTime.holder': '搜索走访反馈时间',
'tqtVisit.companyFeedbackContent.label': '企业反馈详情',
'tqtVisit.companyFeedbackContent.holder': '请输入企业反馈详情',
'tqtVisit.companyFeedbackContent.max': '企业反馈详情最多255个字符',
'tqtVisit.companyFeedbackContent.required': '企业反馈详情必填',
'tqtVisit.searchCompanyFeedbackContent.holder': '搜索企业反馈详情',
'tqtVisit.companyFeedbackImg.label': '企业反馈图片',
'tqtVisit.companyFeedbackImg.holder': '请输入企业反馈图片',
'tqtVisit.companyFeedbackImg.max': '企业反馈图片最多524个字符',
'tqtVisit.companyFeedbackImg.required': '企业反馈图片必填',
'tqtVisit.searchCompanyFeedbackImg.holder': '搜索企业反馈图片',
'tqtVisit.companyFeedbackTime.label': '企业反馈时间',
'tqtVisit.companyFeedbackTime.holder': '请输入企业反馈时间',
'tqtVisit.companyFeedbackTime.max': '企业反馈时间最多null个字符',
'tqtVisit.companyFeedbackTime.required': '企业反馈时间必填',
'tqtVisit.searchCompanyFeedbackTime.holder': '搜索企业反馈时间',
'tqtVisit.status.label': '状态',
'tqtVisit.status.holder': '请输入状态',
'tqtVisit.status.max': '状态最多1个字符',
'tqtVisit.status.required': '状态必填',
'tqtVisit.searchStatus.holder': '搜索状态',
'tqtVisit.jsfUserId.label': '接收方userid',
'tqtVisit.jsfUserId.holder': '请输入接收方userid',
'tqtVisit.jsfUserId.max': '接收方userid最多11个字符',
'tqtVisit.jsfUserId.required': '接收方userid必填',
'tqtVisit.searchJsfUserId.holder': '搜索接收方userid',
},
'zh-TW': {
'tqtVisit.id.label': '',
'tqtVisit.id.holder': '請輸入',
'tqtVisit.id.max': '最多11個字符',
'tqtVisit.id.required': '必填',
'tqtVisit.searchId.holder': '搜索',
'tqtVisit.userId.label': '发起人id',
'tqtVisit.userId.holder': '請輸入发起人id',
'tqtVisit.userId.max': '发起人id最多11個字符',
'tqtVisit.userId.required': '发起人id必填',
'tqtVisit.searchUserId.holder': '搜索发起人id',
'tqtVisit.name.label': '发起人姓名',
'tqtVisit.name.holder': '請輸入发起人姓名',
'tqtVisit.name.max': '发起人姓名最多18個字符',
'tqtVisit.name.required': '发起人姓名必填',
'tqtVisit.searchName.holder': '搜索发起人姓名',
'tqtVisit.concatPhone.label': '联系方式',
'tqtVisit.concatPhone.holder': '請輸入联系方式',
'tqtVisit.concatPhone.max': '联系方式最多11個字符',
'tqtVisit.concatPhone.required': '联系方式必填',
'tqtVisit.searchConcatPhone.holder': '搜索联系方式',
'tqtVisit.createTime.label': '发起时间',
'tqtVisit.createTime.holder': '請輸入发起时间',
'tqtVisit.createTime.max': '发起时间最多null個字符',
'tqtVisit.createTime.required': '发起时间必填',
'tqtVisit.searchCreateTime.holder': '搜索发起时间',
'tqtVisit.duty.label': '职位',
'tqtVisit.duty.holder': '請輸入职位',
'tqtVisit.duty.max': '职位最多54個字符',
'tqtVisit.duty.required': '职位必填',
'tqtVisit.searchDuty.holder': '搜索职位',
'tqtVisit.deptName.label': '单位',
'tqtVisit.deptName.holder': '請輸入单位',
'tqtVisit.deptName.max': '单位最多54個字符',
'tqtVisit.deptName.required': '单位必填',
'tqtVisit.searchDeptName.holder': '搜索单位',
'tqtVisit.visitTime.label': '走访时间',
'tqtVisit.visitTime.holder': '請輸入走访时间',
'tqtVisit.visitTime.max': '走访时间最多null個字符',
'tqtVisit.visitTime.required': '走访时间必填',
'tqtVisit.searchVisitTime.holder': '搜索走访时间',
'tqtVisit.followPerson.label': '随同人员',
'tqtVisit.followPerson.holder': '請輸入随同人员',
'tqtVisit.followPerson.max': '随同人员最多255個字符',
'tqtVisit.followPerson.required': '随同人员必填',
'tqtVisit.searchFollowPerson.holder': '搜索随同人员',
'tqtVisit.visitContent.label': '走访内容',
'tqtVisit.visitContent.holder': '請輸入走访内容',
'tqtVisit.visitContent.max': '走访内容最多255個字符',
'tqtVisit.visitContent.required': '走访内容必填',
'tqtVisit.searchVisitContent.holder': '搜索走访内容',
'tqtVisit.companyCode.label': '统一社会信用代码',
'tqtVisit.companyCode.holder': '請輸入统一社会信用代码',
'tqtVisit.companyCode.max': '统一社会信用代码最多18個字符',
'tqtVisit.companyCode.required': '统一社会信用代码必填',
'tqtVisit.searchCompanyCode.holder': '搜索统一社会信用代码',
'tqtVisit.companyName.label': '企业名称',
'tqtVisit.companyName.holder': '請輸入企业名称',
'tqtVisit.companyName.max': '企业名称最多54個字符',
'tqtVisit.companyName.required': '企业名称必填',
'tqtVisit.searchCompanyName.holder': '搜索企业名称',
'tqtVisit.companyConcatName.label': '企业联系人',
'tqtVisit.companyConcatName.holder': '請輸入企业联系人',
'tqtVisit.companyConcatName.max': '企业联系人最多128個字符',
'tqtVisit.companyConcatName.required': '企业联系人必填',
'tqtVisit.searchCompanyConcatName.holder': '搜索企业联系人',
'tqtVisit.companyConcatPhone.label': '联系方式',
'tqtVisit.companyConcatPhone.holder': '請輸入联系方式',
'tqtVisit.companyConcatPhone.max': '联系方式最多11個字符',
'tqtVisit.companyConcatPhone.required': '联系方式必填',
'tqtVisit.searchCompanyConcatPhone.holder': '搜索联系方式',
'tqtVisit.visitFeedbackContent.label': '走访员反馈详情',
'tqtVisit.visitFeedbackContent.holder': '請輸入走访员反馈详情',
'tqtVisit.visitFeedbackContent.max': '走访员反馈详情最多255個字符',
'tqtVisit.visitFeedbackContent.required': '走访员反馈详情必填',
'tqtVisit.searchVisitFeedbackContent.holder': '搜索走访员反馈详情',
'tqtVisit.visitFeedbackImg.label': '走访员反馈图片',
'tqtVisit.visitFeedbackImg.holder': '請輸入走访员反馈图片',
'tqtVisit.visitFeedbackImg.max': '走访员反馈图片最多524個字符',
'tqtVisit.visitFeedbackImg.required': '走访员反馈图片必填',
'tqtVisit.searchVisitFeedbackImg.holder': '搜索走访员反馈图片',
'tqtVisit.visitFeedbackTime.label': '走访反馈时间',
'tqtVisit.visitFeedbackTime.holder': '請輸入走访反馈时间',
'tqtVisit.visitFeedbackTime.max': '走访反馈时间最多null個字符',
'tqtVisit.visitFeedbackTime.required': '走访反馈时间必填',
'tqtVisit.searchVisitFeedbackTime.holder': '搜索走访反馈时间',
'tqtVisit.companyFeedbackContent.label': '企业反馈详情',
'tqtVisit.companyFeedbackContent.holder': '請輸入企业反馈详情',
'tqtVisit.companyFeedbackContent.max': '企业反馈详情最多255個字符',
'tqtVisit.companyFeedbackContent.required': '企业反馈详情必填',
'tqtVisit.searchCompanyFeedbackContent.holder': '搜索企业反馈详情',
'tqtVisit.companyFeedbackImg.label': '企业反馈图片',
'tqtVisit.companyFeedbackImg.holder': '請輸入企业反馈图片',
'tqtVisit.companyFeedbackImg.max': '企业反馈图片最多524個字符',
'tqtVisit.companyFeedbackImg.required': '企业反馈图片必填',
'tqtVisit.searchCompanyFeedbackImg.holder': '搜索企业反馈图片',
'tqtVisit.companyFeedbackTime.label': '企业反馈时间',
'tqtVisit.companyFeedbackTime.holder': '請輸入企业反馈时间',
'tqtVisit.companyFeedbackTime.max': '企业反馈时间最多null個字符',
'tqtVisit.companyFeedbackTime.required': '企业反馈时间必填',
'tqtVisit.searchCompanyFeedbackTime.holder': '搜索企业反馈时间',
'tqtVisit.status.label': '状态',
'tqtVisit.status.holder': '請輸入状态',
'tqtVisit.status.max': '状态最多1個字符',
'tqtVisit.status.required': '状态必填',
'tqtVisit.searchStatus.holder': '搜索状态',
'tqtVisit.jsfUserId.label': '接收方userid',
'tqtVisit.jsfUserId.holder': '請輸入接收方userid',
'tqtVisit.jsfUserId.max': '接收方userid最多11個字符',
'tqtVisit.jsfUserId.required': '接收方userid必填',
'tqtVisit.searchJsfUserId.holder': '搜索接收方userid',
},
'en-US': {
'tqtVisit.id.label': '',
'tqtVisit.id.holder': 'Enter ',
'tqtVisit.id.max': ' max length: 11',
'tqtVisit.id.required': ' required',
'tqtVisit.searchId.holder': 'Search ',
'tqtVisit.userId.label': '发起人id',
'tqtVisit.userId.holder': 'Enter 发起人id',
'tqtVisit.userId.max': '发起人id max length: 11',
'tqtVisit.userId.required': '发起人id required',
'tqtVisit.searchUserId.holder': 'Search 发起人id',
'tqtVisit.name.label': '发起人姓名',
'tqtVisit.name.holder': 'Enter 发起人姓名',
'tqtVisit.name.max': '发起人姓名 max length: 18',
'tqtVisit.name.required': '发起人姓名 required',
'tqtVisit.searchName.holder': 'Search 发起人姓名',
'tqtVisit.concatPhone.label': '联系方式',
'tqtVisit.concatPhone.holder': 'Enter 联系方式',
'tqtVisit.concatPhone.max': '联系方式 max length: 11',
'tqtVisit.concatPhone.required': '联系方式 required',
'tqtVisit.searchConcatPhone.holder': 'Search 联系方式',
'tqtVisit.createTime.label': '发起时间',
'tqtVisit.createTime.holder': 'Enter 发起时间',
'tqtVisit.createTime.max': '发起时间 max length: null',
'tqtVisit.createTime.required': '发起时间 required',
'tqtVisit.searchCreateTime.holder': 'Search 发起时间',
'tqtVisit.duty.label': '职位',
'tqtVisit.duty.holder': 'Enter 职位',
'tqtVisit.duty.max': '职位 max length: 54',
'tqtVisit.duty.required': '职位 required',
'tqtVisit.searchDuty.holder': 'Search 职位',
'tqtVisit.deptName.label': '单位',
'tqtVisit.deptName.holder': 'Enter 单位',
'tqtVisit.deptName.max': '单位 max length: 54',
'tqtVisit.deptName.required': '单位 required',
'tqtVisit.searchDeptName.holder': 'Search 单位',
'tqtVisit.visitTime.label': '走访时间',
'tqtVisit.visitTime.holder': 'Enter 走访时间',
'tqtVisit.visitTime.max': '走访时间 max length: null',
'tqtVisit.visitTime.required': '走访时间 required',
'tqtVisit.searchVisitTime.holder': 'Search 走访时间',
'tqtVisit.followPerson.label': '随同人员',
'tqtVisit.followPerson.holder': 'Enter 随同人员',
'tqtVisit.followPerson.max': '随同人员 max length: 255',
'tqtVisit.followPerson.required': '随同人员 required',
'tqtVisit.searchFollowPerson.holder': 'Search 随同人员',
'tqtVisit.visitContent.label': '走访内容',
'tqtVisit.visitContent.holder': 'Enter 走访内容',
'tqtVisit.visitContent.max': '走访内容 max length: 255',
'tqtVisit.visitContent.required': '走访内容 required',
'tqtVisit.searchVisitContent.holder': 'Search 走访内容',
'tqtVisit.companyCode.label': '统一社会信用代码',
'tqtVisit.companyCode.holder': 'Enter 统一社会信用代码',
'tqtVisit.companyCode.max': '统一社会信用代码 max length: 18',
'tqtVisit.companyCode.required': '统一社会信用代码 required',
'tqtVisit.searchCompanyCode.holder': 'Search 统一社会信用代码',
'tqtVisit.companyName.label': '企业名称',
'tqtVisit.companyName.holder': 'Enter 企业名称',
'tqtVisit.companyName.max': '企业名称 max length: 54',
'tqtVisit.companyName.required': '企业名称 required',
'tqtVisit.searchCompanyName.holder': 'Search 企业名称',
'tqtVisit.companyConcatName.label': '企业联系人',
'tqtVisit.companyConcatName.holder': 'Enter 企业联系人',
'tqtVisit.companyConcatName.max': '企业联系人 max length: 128',
'tqtVisit.companyConcatName.required': '企业联系人 required',
'tqtVisit.searchCompanyConcatName.holder': 'Search 企业联系人',
'tqtVisit.companyConcatPhone.label': '联系方式',
'tqtVisit.companyConcatPhone.holder': 'Enter 联系方式',
'tqtVisit.companyConcatPhone.max': '联系方式 max length: 11',
'tqtVisit.companyConcatPhone.required': '联系方式 required',
'tqtVisit.searchCompanyConcatPhone.holder': 'Search 联系方式',
'tqtVisit.visitFeedbackContent.label': '走访员反馈详情',
'tqtVisit.visitFeedbackContent.holder': 'Enter 走访员反馈详情',
'tqtVisit.visitFeedbackContent.max': '走访员反馈详情 max length: 255',
'tqtVisit.visitFeedbackContent.required': '走访员反馈详情 required',
'tqtVisit.searchVisitFeedbackContent.holder': 'Search 走访员反馈详情',
'tqtVisit.visitFeedbackImg.label': '走访员反馈图片',
'tqtVisit.visitFeedbackImg.holder': 'Enter 走访员反馈图片',
'tqtVisit.visitFeedbackImg.max': '走访员反馈图片 max length: 524',
'tqtVisit.visitFeedbackImg.required': '走访员反馈图片 required',
'tqtVisit.searchVisitFeedbackImg.holder': 'Search 走访员反馈图片',
'tqtVisit.visitFeedbackTime.label': '走访反馈时间',
'tqtVisit.visitFeedbackTime.holder': 'Enter 走访反馈时间',
'tqtVisit.visitFeedbackTime.max': '走访反馈时间 max length: null',
'tqtVisit.visitFeedbackTime.required': '走访反馈时间 required',
'tqtVisit.searchVisitFeedbackTime.holder': 'Search 走访反馈时间',
'tqtVisit.companyFeedbackContent.label': '企业反馈详情',
'tqtVisit.companyFeedbackContent.holder': 'Enter 企业反馈详情',
'tqtVisit.companyFeedbackContent.max': '企业反馈详情 max length: 255',
'tqtVisit.companyFeedbackContent.required': '企业反馈详情 required',
'tqtVisit.searchCompanyFeedbackContent.holder': 'Search 企业反馈详情',
'tqtVisit.companyFeedbackImg.label': '企业反馈图片',
'tqtVisit.companyFeedbackImg.holder': 'Enter 企业反馈图片',
'tqtVisit.companyFeedbackImg.max': '企业反馈图片 max length: 524',
'tqtVisit.companyFeedbackImg.required': '企业反馈图片 required',
'tqtVisit.searchCompanyFeedbackImg.holder': 'Search 企业反馈图片',
'tqtVisit.companyFeedbackTime.label': '企业反馈时间',
'tqtVisit.companyFeedbackTime.holder': 'Enter 企业反馈时间',
'tqtVisit.companyFeedbackTime.max': '企业反馈时间 max length: null',
'tqtVisit.companyFeedbackTime.required': '企业反馈时间 required',
'tqtVisit.searchCompanyFeedbackTime.holder': 'Search 企业反馈时间',
'tqtVisit.status.label': '状态',
'tqtVisit.status.holder': 'Enter 状态',
'tqtVisit.status.max': '状态 max length: 1',
'tqtVisit.status.required': '状态 required',
'tqtVisit.searchStatus.holder': 'Search 状态',
'tqtVisit.jsfUserId.label': '接收方userid',
'tqtVisit.jsfUserId.holder': 'Enter 接收方userid',
'tqtVisit.jsfUserId.max': '接收方userid max length: 11',
'tqtVisit.jsfUserId.required': '接收方userid required',
'tqtVisit.searchJsfUserId.holder': 'Search 接收方userid',
}
};